export const Plus = () => (
  <svg
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    className="u-icon u-icon--utility-plus"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.16963 7.23084C3.66857 7.20906 3.41805 7.44869 3.41805 7.94975C3.41805 8.45081 3.66858 8.69044 4.16963 8.66865L7.24842 8.70133L7.28109 11.7801C7.25931 12.2812 7.49894 12.5317 8 12.5317C8.50106 12.5317 8.74069 12.2812 8.71891 11.7801L8.75158 8.70133L11.8304 8.66865C12.3314 8.69044 12.582 8.45081 12.582 7.94975C12.582 7.44869 12.3314 7.20906 11.8304 7.23084L8.75158 7.19816L8.71891 4.11938C8.74069 3.61832 8.50106 3.3678 8 3.3678C7.49894 3.3678 7.25931 3.61832 7.28109 4.11938L7.24842 7.19816L4.16963 7.23084Z"
      fill="currentColor"
    />
  </svg>
);
